import CustomFieldsCriticalAdvisory from "./custom_fields_critical_advisory/CustomFieldsCriticalAdvisoryComponent";
import CustomFieldsHighAdvisory from "./custom_fields_high_advisory/CustomFieldsHighAdvisoryComponent";
import CustomFieldsMediumAdvisory from "./custom_fields_medium_advisory/CustomFieldsMediumAdvisoryComponent";
import CustomFieldsEox from "./custom_fields_eox/CustomFieldsEoxComponent";
import CustomFieldsSnContractNo from "./custom_fields_sn_contract_no/CustomFieldsSnContractNoComponent";
import CustomFieldsSnContractEndDate from "./custom_fields_sn_contract_end_date/CustomFieldsSnContractEndDateComponent";
import CustomFieldsColumn from "./custom_fields/CustomFieldsComponent";

export const DEVICE_CAPTURE_STATUSES = {
    UNKNOWN: {
        name: "UNKNOWN",
        title: "Unknown",
        icon: "common.unknown",
    },
    ERROR: {
        name: "ERROR",
        title: "Error",
        icon: "common.error",
    },
    PENDING: {
        name: "PENDING",
        title: "Pending",
        icon: "common.pending",
    },
    QUEUED: {
        name: "QUEUED",
        title: "Queued",
        icon: "common.arrow",
    },
    RUNNING: {
        name: "RUNNING",
        title: "Running",
        icon: "common.loading",
    },
    CHANGED: {
        name: "CHANGED",
        title: "Changed",
        icon: "configdrift.changed",
    },
    UNCHANGED: {
        name: "UNCHANGED",
        title: "Unchanged",
        icon: "configdrift.same",
    },
    // For Legacy data support
    NOT_CHANGED: {
        name: "UNCHANGED",
        title: "Unchanged",
        icon: "configdrift.same",
    },
};

export const DEVICE_DISCOVERY_STATUSES = {
    UNKNOWN: {
        name: "UNKNOWN",
        title: "Unknown",
        icon: "common.unknown",
        dashboardIcon: "g-icon-unknown",
    },
    UNREACHABLE: {
        name: "UNREACHABLE",
        title: "Unreachable",
        icon: "common.error",
        dashboardIcon: "g-icon-error",
    },
    ERROR: {
        name: "ERROR",
        title: "Error",
        icon: "common.error",
        dashboardIcon: "g-icon-error",
    },
    PENDING: {
        name: "PENDING",
        title: "Pending",
        icon: "common.pending",
        dashboardIcon: "g-icon-pending",
    },
    QUEUED: {
        name: "QUEUED",
        title: "Queued",
        icon: "common.arrow",
        dashboardIcon: "g-icon-arrow",
    },
    RUNNING: {
        name: "RUNNING",
        title: "Running",
        icon: "common.loading",
        dashboardIcon: "g-icon-loading",
    },
    DISCOVERED: {
        name: "DISCOVERED",
        title: "Discovered",
        icon: "devicemanager.discovered",
        dashboardIcon: "g-icon-device_discovery_success",
    },
};

export const AUDIT_STATUSES = {
    ERROR: {
        name: "ERROR",
        title: "Error",
        icon: "common.error",
    },
    PENDING: {
        name: "PENDING",
        title: "Pending",
        icon: "common.pending",
    },
    QUEUED: {
        name: "QUEUED",
        title: "Queued",
        icon: "common.arrow",
    },
    RUNNING: {
        name: "RUNNING",
        title: "Running",
        icon: "common.loading",
    },
    PASSED: {
        name: "PASSED",
        title: "Passed",
        icon: "configdrift.audit_policy_passed",
    },
    FAILED: {
        name: "FAILED",
        title: "Failed",
        icon: "configdrift.audit_policy_failed",
    },
    UNKNOWN: {
        name: "UNKNOWN",
        title: "Unknown",
        icon: "common.unknown",
    },
};

export const DEVICE_MANAGEMENT_STATES = {
    MANAGED: {
        name: "MANAGED",
        title: "Managed",
    },
    UNMANAGED: {
        name: "UNMANAGED",
        title: "Unmanaged",
    },
    INVENTORY_ONLY: {
        name: "INVENTORY_ONLY",
        title: "Inventory Only",
    },
};

export const LICENSE_STATUS = {
    true: {
        name: true,
        title: "Yes",
    },
    false: {
        name: false,
        title: "No",
    },
};

export const DISRUPTIVE_STATUS = {
    true: {
        name: true,
        title: "Yes",
    },
    false: {
        name: false,
        title: "No",
    },
};

//remove soon
export const DEVICE_CUSTOM_FIELDS = [
    {
        id: "2abc8e82-4631-4fa1-ab66-d414bb4e8e05",
        columnRenderer: CustomFieldsCriticalAdvisory,
    },
    {
        id: "9ed3ecea-82a4-4141-8d12-f41ec7e04367",
        columnRenderer: CustomFieldsHighAdvisory,
    },
    {
        id: "8c467f86-c54c-450a-a2b8-c4f57a78b82d",
        columnRenderer: CustomFieldsMediumAdvisory,
    },
    {
        id: "118d6b5c-1d81-4aa3-a2d8-ad50585ff79b",
        columnRenderer: CustomFieldsEox,
    },
    {
        id: "092f60e9-d47f-469e-abbf-004781107833",
        columnRenderer: CustomFieldsSnContractNo,
    },
    {
        id: "0c6644ce-a700-476a-82f9-16e4821ed430",
        columnRenderer: CustomFieldsSnContractEndDate,
    },
    {
        id: "43236483-c177-42f1-aed5-b972ebe23eb8",
        columnRenderer: CustomFieldsColumn,
    },
];

export const ACCESS_STATUS = {
    UNKNOWN: "UNKNOWN",
    OK: "OK",
    UNREACHABLE: "UNREACHABLE",
    INVALID_CREDENTIALS: "INVALID_CREDENTIALS",
    UNDISCOVERABLE: "UNDISCOVERABLE",
};

export const ACCESS_STATUS_LABELS = {
    UNKNOWN: {
        name: "UNKNOWN",
        title: "Unknown",
    },
    OK: {
        name: "OK",
        title: "OK",
    },
    UNREACHABLE: {
        name: "UNREACHABLE",
        title: "Unreachable",
    },
    INVALID_CREDENTIALS: {
        name: "INVALID_CREDENTIALS",
        title: "Invalid Credentials",
    },
    UNDISCOVERABLE: {
        name: "UNDISCOVERABLE",
        title: "Undiscoverable",
    },
};

export const SITE_PATH_LIST = {
    PATH: {
        name: "/",
        title: "/",
    },
};
